import { Switch, Route, Redirect, useLocation } from "wouter";
import { isAppRoutePath } from "@shared/constants/public-routes";
import NotFoundPage from "@/pages/NotFoundPage";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyEmail from "@/pages/VerifyEmail";
import VerifySms from "@/pages/VerifySms";
import RegisterExecutor from "@/pages/RegisterExecutor";
import RegisterAdvisor from "@/pages/RegisterAdvisor";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";

export function AuthShell() {
  const [location] = useLocation();
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/signup" component={Signup} />
      <Route path="/verify-email" component={VerifyEmail} />
      <Route path="/verify-sms" component={VerifySms} />
      <Route path="/register" component={RegisterExecutor} />
      <Route path="/register/advisor" component={RegisterAdvisor} />
      <Route path="/forgot-password" component={ForgotPasswordPage} />
      <Route path="/reset-password" component={ResetPasswordPage} />
      {/*
        Unmatched path, logged out (s216, SEO phase 1 item 5).

        An APP path keeps the original behaviour — redirect to /login, so a bookmark to
        /dashboard still offers a sign-in. Anything else is a genuine wrong address and renders
        the `noindex` 404 instead of an indexable login page: a crawler hitting /junk-path used
        to be handed the login screen carrying the HOME page's title and description.

        🔴 The redirect never preserved the intended destination (it is a bare Redirect to
        "/login"), so nothing that used to survive this branch is lost by splitting it.
      */}
      <Route>
        {isAppRoutePath(location) ? <Redirect to="/login" /> : <NotFoundPage />}
      </Route>
    </Switch>
  );
}
